import React from 'react';
import './editCompany.scss';
import Header from '../Header/header';
import Footer from '../../containers/Footer/footer';
import getEditCompany from '../../services/getEditCompany';
import toastNotify from '../../utils/toastNotifier';
import editLogo from '../../services/editLogo';
import getCompanyByID from '../../services/getCompanyByID';
import withRouter from '../withRouter';
import { Navigate } from 'react-router-dom';
import { auth as AuthObject } from '../../services/login'
import cookie from '../../cookieHelper/cookie';






class EditCompany extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            imgSrc: null,
            items: [],
            tokencheck:true,
        }

        this.flag = 0;
        this.imageValue;
    }
    componentDidMount = async () => {
        console.log('inside componentDidMount()');
        var str = window.location.pathname;
        var pos = str.lastIndexOf("/");

        var id = str.substr(pos + 1, str.length);

        var companyId = id;

        var value = await getCompanyByID(companyId);
        if( value && value["status"] == 200)
        {
            var enterValue = value.data.data[0].companies[0];
        }
        else{

            const response = JSON.parse(value.request.response);
            const code = response?.status?.code;
            if (code == 10411 || code == 10412 || code == 10416 || code == 10417) {
                this.setState({ tokencheck: false });
                cookie.delete_cookie(process.env.REACT_APP_COOKIE_NAME);
                cookie.delete_cookie('loginProfileInfo');
                AuthObject.isAuthenticated = false;
            }


        }

        document.getElementById('companyName').value = enterValue.companyName;
        this.setState({
            items: enterValue
        })
        console.log(this.state.items);

        // Premium checkbox 
        var getElement = document.getElementsByName('premium');
        if (enterValue.isPremium === 1) {
            getElement[0].checked = true;
        }
        else {
            getElement[1].checked = true;
        }
    }

    companyValidate = () => {
        var companyName = document.getElementById('companyName').value;

        if (companyName.length == "") {
            document.getElementById('companyNameSpace').innerHTML = "Please fill the field";
            return false;
        }
        else {
            document.getElementById('companyNameSpace').innerHTML = "";
            return true;
        }
    }
    setPremium(event) {

        this.flag = event.target.value;
    }

    sendCompanyData = async (e) => {

        e.preventDefault();

        var str = window.location.pathname;
        var pos = str.lastIndexOf("/");

        var id = str.substr(pos + 1, str.length);

        var premiumVal = this.flag;

        var ans = this.companyValidate();
        var companyId = id;
        const data = {
            companyName: document.getElementById('companyName').value,
            isPremium: premiumVal
        }

        if (ans == true) {
            try {
                var value = await getEditCompany(data, companyId);
                if (value.data.status.code == 10200) {
                    toastNotify(1, "Successfully Edited Company");
                }
                else {
                    toastNotify(3, "Please try Later");

                }

            }
            catch (err) {
                toastNotify(3, "Please try Later");
            }
        }

    }
    previewFile = () => {
        var preview = document.getElementById('logo_img');
        var file = document.querySelector('input[type=file]').files[0];

        var reader = new FileReader();

        reader.addEventListener("load", () => {
            preview.src = reader.result;
            const myResult = reader.result;

            this.setState({
                imgSrc: myResult
            })
            //  -This has src of the image
        }, false);

        if (file) {

            reader.readAsDataURL(file);
        }
    }
    logoValidation = () => {
        var formData = new FormData();

        var file = document.getElementById("img").files[0];

        if (file) {
            formData.append("Filedata", file);
            var t = file.type.split('/').pop().toLowerCase();
            if (t != "jpeg" && t != "jpg" && t != "png") {
                alert('Please select a valid image file');
                document.getElementById("img").value = '';
                return false;
            }
            if (file.size > 1024 * 200) {
                alert('Max Upload size is 200KB only');
                document.getElementById("img").value = '';
                return false;
            }
            else {
                console.log("It can be uploaded");
                // document.getElementById("img").value = 'uploaded';
                return true;
            }

        }
        else {
            alert('No image Selected');
            return false;
        }
    }
    editLogoData = async (e) => {
        e.preventDefault();
        var form = new FormData();
        form.append("companyLogo", document.getElementById("img").files[0])
        console.log('form:',form);
        const data = {
            companyLogo: form
        }
        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        }

        var ans = this.logoValidation();

        var str = window.location.pathname;
        var pos = str.lastIndexOf("/");

        var id = str.substr(pos + 1, str.length);

        var companyId = id;

        // var companyId = document.getElementById('companyId').value;
        // console.log("companyId:",companyId);
        if (ans == true) {
            var value = await editLogo(form, companyId, config);

            if (value?.status?.code == 10200) {
                toastNotify(1, "Successfully Changed Logo");
            } else {

                const response = value?.response || value?.request?.response;
            
                if (response) {

            
                    const code = response?.data?.status?.code ?? null;


            
                    if (code == 10411 || code == 10412 || code == 10416 || code == 10417) {

                        this.setState({ tokencheck: false });
                        cookie.delete_cookie(process.env.REACT_APP_COOKIE_NAME);
                        cookie.delete_cookie('loginProfileInfo');
                        AuthObject.isAuthenticated = false;
                    } else {
                        toastNotify(3, "Please try later.");
                    }
                } else {
                    toastNotify(3, "Network error. Please check your connection.");
                }
            }
            

        }
        else {
            toastNotify(3, "Please try Later");

        }
    }

    render() {

        if (!this.state.tokencheck) {
            return <Navigate to={'/'} />
        }

        console.log('inside render');
        const { items } = this.state;

        return (
            <div>
                <Header />


                <section className="editCompany_header">
                    <div className="wrapper">
                        <h1>Edit Company</h1>

                        <div className="box-design-1">
                            <div className="form-group">

                                <label><b>Company Name:</b></label>
                                <input type="text" id="companyName" className="form_input" placeholder="Enter Name"
                                // value={this.state.items.companyName} 
                                />
                                <div id="companyNameSpace"></div>

                                <div className="spacing">
                                    <label><b>Premium:</b></label>
                                    <div className="spacing"
                                        onChange={this.setPremium.bind(this)} >
                                        <input className="premiumCheck" type="radio" value="1" name="premium" /> Yes
                                        <input className="premiumCheck" type="radio" value="0" name="premium" /> No
                                    </div>
                                </div>


                            </div>
                            <button type="submit" id="companyBtnSubmit" className="btn-default" onClick={this.sendCompanyData}>Submit</button>
                            <div id="companyPremiumSubmit"></div>
                        </div>
                        <div className="box-design-2">
                            <div className="form-group">
                                <label><b>Change Logo:</b></label>
                                <input type="file" id="img" className="logoSpacing"
                                    onChange={this.previewFile}
                                />

                            </div>
                            <div id="logo">
                                <img id="logo_img" src={"https://s3.ap-south-1.amazonaws.com/storiesmedia/companyLogo/" + this.state.items.companyLogo} />
                            </div>
                            <div className="form-group">
                                <button type="submit" id="logoBtnSubmit" className="btn-default" onClick={this.editLogoData}>Submit</button>
                                <div id="changeLogoSubmit"></div>
                            </div>
                        </div>

                    </div>
                </section>
                <Footer />
            </div>

        )
    }
}
export default withRouter(EditCompany);